module.exports = __webpack_public_path__ + "img/hydrologiskedata.e3a86d2d.jpg";